"use client"

import type React from "react"
import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useToast } from "../../context/ToastContext"
import "./AuthSuccess.css"
import { useAuth } from "../../context/AuthContext"

const AuthSuccess: React.FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [countdown, setCountdown] = useState(5)
  const { authoriseSalesforce } = useAuth()
  const { error } = useToast()

  const provider = searchParams.get("provider")
  // const tenantId = searchParams.get("tenant_id")

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          navigate("/dashboard/connect-accounts")
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [navigate])

  const handleConnectNext = async() => {
    if (provider === "hubspot") {
      // Redirect to Salesforce OAuth
      const tenantKey = localStorage.getItem("hubspot_tenant_id")
        if(tenantKey){
          let conveted = parseInt(tenantKey)
          const response = await authoriseSalesforce(conveted);
          if(response.status === 200){
            const salesforceAuthUrl = `${response.data}`
            window.location.href = salesforceAuthUrl
            // window.open(response.data, '_blank')
          }
        }else{
          error("C")
        }
    } else {
      navigate("/dashboard/choose-sync")
    }
  }

  const handleBackToDashboard = () => {
    navigate("/dashboard/connect-accounts")
  }

  return (
    <div className="auth-success">
      <div className="auth-success-container">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#10B981" strokeWidth="2" fill="none" />
            <path d="m9 12 2 2 4-4" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1 className="success-title">Authorization Successful!</h1>

        <div className="success-message">
          <p>
            NetzSync has connected your {provider === "hubspot" ? "HubSpot" : "Salesforce"} account
            {/* {tenantId &&  tenantId != null && (
              <span className="tenant-info">
                <br />
                (Tenant ID: {tenantId}).
              </span>
            )} */}
          </p>
        </div>

        <p className="sync-message">Bridging HubSpot and Salesforce for seamless sync.</p>

        <div className="action-buttons">
          {provider === "hubspot" ? (
            <button className="connect-next-btn" onClick={handleConnectNext}>
              Connect Salesforce Next
            </button>
          ) : (
            <button className="continue-btn" onClick={() => navigate("/dashboard/choose-sync")}>
              Continue to Sync Setup
            </button>
          )}
        </div>

        <div className="auto-redirect">
          <p>Automatically redirecting in {countdown} seconds...</p>
          <button className="back-btn" onClick={handleBackToDashboard}>
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  )
}

export default AuthSuccess
